import React from 'react';
import { AppSectionSkeleton } from '@wix/app-market-components';
import { useUserContext } from '@wix/app-market-core';

export const AppsSectionsSkeleton: React.FunctionComponent<{
  rows?: number;
  boxCount?: number;
}> = ({ rows, boxCount = 8 }) => {
  const { isMobile } = useUserContext();

  return (
    <>
      {Array.from({ length: 8 }).map((_value, index) => (
        <AppSectionSkeleton
          key={index}
          boxCount={boxCount}
          rows={rows}
          minColumns={isMobile ? 1 : 3}
        />
      ))}
    </>
  );
};
